<div class="container">
    <h3>Teckenförklaring</h3>
    @for (layer of this.trvMapService.trvMap!.trvLayer.getVisibleWmsLayer(); track layer) {
        <div class="mb-2">
            @if (layer.legendGraphics && this.trvMapService.trvMap!.trvLayer.getLayerData(layer, "hideLabel") != true) {
                <div>
                    <b>{{ layer.name }}</b>
                    <br/>
                    <img [src]="getLegendGraphics(layer)" [alt]="'Tecken för {{layer.name}} i kartan'"/>
                </div>
            }
        </div>
    } 
    
    @if(hasNoVisibleLabels()) {
       
        <div>
            Inga dataprodukter är valda.
        </div>
    }

</div>
